module.exports = __webpack_public_path__ + "img/touragency_guide.9a788dc3.svg";